<template>
<div>
  <el-dialog title="变更角色" :visible.sync="visible" width="530px" class="my-dialog-template" :close-on-click-modal="false">
    <el-form :inline="true" :model="formData" ref='formRef' class="my-form-template" label-width="160px" v-loading="loading">
      <el-form-item label="请选择变更后的角色" prop="roleId" class="full" :rules="$tools.formRule.required('请选择')">
        <el-select v-model="formData.roleId" placeholder="请选择" filterable>
          <el-option :label="item.name" :value="item.id" v-for="(item,index) in roleList" :key="index" v-if="item.id!=roleId"></el-option>
        </el-select>
      </el-form-item>
    </el-form>
    <div class="dialog-footer">
      <el-button class="org-btn" plain @click="visible=false">取消</el-button>
      <el-button @click="save()">确定</el-button>
    </div>
  </el-dialog>
</div>
  
</template>
<script>
export default {
  data: () => ({
    visible: false,
    loading: false,
    showPass:false,
    formData:{},
    roleList:[],
    roleId:"",
  }),
  components: {},
  methods: {
    async open(data={}) {
      const loading = this.$notice.loading();
      await this.getRoleList();//获取所有权限菜单
      await this.getDetailData(data.id);//获取所有权限菜单
      this.visible = true
      this.$refs.formRef&&this.$refs.formRef.clearValidate()
      loading.close();
    },
    // 详情数据
    getDetailData(id){
      return this.$http({
        url:'/master/mechanUser/read/detail',
        type:'GET',
        params:{id},
      }).then(res=>{
        this.roleId = res.data.roleId
        res.data.roleId = "";
        this.formData = res.data;
      })
    },
    // 角色列表
    getRoleList(){
      return this.$http({
        url:'/master/mechanRole/list',
        type:'PUT',
        params:{
          pageNum:1,
          pageSize:99,
        },
      }).then(res=>{
        this.roleList = res.data;
      })
    },
    save(isNext) {
      this.$refs['formRef'].validate(async (valid) => {
        if (valid) {
          this.$http({
            url:'/master/mechanUserPermission/editRole',
            type:'POST',
            params:{
              roleId:this.formData.roleId,
              mechanUserId:this.formData.id
            },
          }).then(res=>{
            this.$message.success("保存成功");
            this.$emit("reload")
            this.visible = false
          })
          
        }
      })
    },
  },
}
</script>
<style lang='scss' scoped>
.my-dialog-template {
  /deep/ {
    .el-form {
      align-items: flex-start;
    }
    .password-box {
      .info-text {
        font-size: 12px;
        color: #888;
        position: absolute;
        left: -90px;
        width: 430px;
        top: 32px;
      }
      .el-form-item__content {
        padding-bottom: 25px;
      }
    }
  }
}
</style>